/**
 * Products Module
 * 
 * Provide functionality to the product pages
 * 
 * TODO
    Consider including this only on the product pages to reduce page load.
 */
$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.products = function () {

        var initModule = function () {

            // Product carousel grid
            // Used for product header
            $('.carousel--nav').on('click', '.carousel__item', function () {
                var index = $(this).index();
                $('.carousel--nav').flickity('select', index);
                $('.carousel--large-1').flickity('select', index);

                var indexMax = $(this).parent().children().length - 1,
                    index1 = index + 1,
                    index2 = index + 2;

                if (index1 > indexMax) index1 = index1 % indexMax;
                if (index2 > indexMax) index2 = index2 % indexMax;

                $('.carousel--large-2').flickity('select', index1);
                $('.carousel--large-3').flickity('select', index2);
            });

            // Handle product selector changes
            // Listen to product selector for option changes and ajax load related variant
            $('.js-variant-option input').change(function () {
                loadVariant();
            });

            // Accessory Modal
            $('.js-accessories-container').on('click', '.js-accessory', function (event) {
                var url = $(this).attr('data-url');
                pz.viewportModal.load(url);
            });

            // expedited info modal trigger
            $('.js-display-expedited-info-modal').on('click', function(event) {
                event.preventDefault();
                displayExpeditedInfoModal();
            });

        };

        // load variant
        var loadVariant = function() {
            var $form = $('.js-variant-options-form'),
                data = $form.serialize(),
                url = $form.attr('data-url');

            // submit form
            $.post(url, data, function (result) {

                // attach result to DOM and replace history
                $('.js-variant-container').html(result).imagesLoaded().then(function(){
                    $('[data-mh]').matchHeight();

                    // replace history state (w/o adding new)
                    var variantUrl = $('.js-variant').attr('data-url');
                    if (window.history.replaceState) {
                       window.history.replaceState({}, null, variantUrl);
                    }

                });

                // move accessories div
                $('.js-accessories-container').html('');
                $('.js-accessories-temp-container .js-compatible-accessories').appendTo('.js-accessories-container');

            }, 'html').fail(function () {
                // TODO: Fail more gracefully
                console.log("error");
            });
        }

        // display expedited info modal
        var displayExpeditedInfoModal = function() {
            if ($('.js-expedited-imprinting-msg').length) {
                var html = $('.js-expedited-imprinting-msg').html();
                pz.viewportModal.load('', html);
            }
        };

        // View accessories
        // closes the viewportModal and scrolls to accessories (used by viewport model link)
        var viewAccessories = function () {
            pz.viewportModal.close();
            scrollToAccessories();
        };

        // Scroll window to accessories
        var scrollToAccessories = function () {
            if ($('.js-compatible-accessories').length) {
                var ypos = $('.js-accessories-container').offset().top; // - $('.js-flash').outerHeight();
                TweenLite.to($(window), 1, { scrollTo: { y: ypos }, ease: Power2.easeOut, delay: 0.25 });
            }
        };

        return {
            initModule: initModule,
            loadVariant: loadVariant,
            viewAccessories: viewAccessories,
            scrollToAccessories: scrollToAccessories
        };
    }();

    pz.products.initModule();
});